import { store } from "@/store";
import { ScheduleRest } from "@/services/rest/schedule.rest";
import ScheduleInterface from "@/interfaces/Schedule.interface";

export class ScheduleService{
    constructor(
        private _schedule = new ScheduleRest()
    ){}

    getSchedule(params: any){
        return this._schedule.getSchedule(params).then((response) => {
            store.dispatch('schedule/setSchedules', response)
        });
    }

    getScheduleById(id: any){
        return this._schedule.getScheduleById(id).then((response) => {
            store.dispatch('schedule/setScheduleId', response)
        });
    }

    addSchedule(data: any){
        return this._schedule.createSchedule(data);
    }

    updateSchedule(id: any, data: ScheduleInterface){
        return this._schedule.updateSchedule(id, data);
    }

    deleteSchedule(id: any){
        return this._schedule.deleteSchedule(id);
    }
}